"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCustoText = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../utils/hooks");
const hook_1 = require("../hook");
const texts_1 = require("../texts");
const errors_1 = require("../../utils/errors");
function buildCustoText(hook, getTextTransformationHook, path, defaultValue) {
    const useVal = () => {
        let val = hook();
        if (val === undefined && defaultValue !== undefined) {
            val = defaultValue;
        }
        return val;
    };
    const comp = react_1.default.forwardRef(function CustComponentWrapper(props, ref) {
        const val = useVal();
        const valRef = react_1.useRef(val);
        const transformationHook = getTextTransformationHook && getTextTransformationHook();
        const transformationHookRef = react_1.useRef(transformationHook);
        valRef.current = val;
        const dep1 = val instanceof hook_1.CustoHook ? val.unsafelyGetOriginalFn() : null;
        const dep2 = transformationHook instanceof hook_1.CustoHook
            ? transformationHook.unsafelyGetOriginalFn()
            : null;
        const key = hooks_1.useDepsVersion([
            hooks_1.useVersion(dep1, val instanceof hook_1.CustoHook && val.isSafe),
            hooks_1.useVersion(dep2, transformationHook instanceof hook_1.CustoHook &&
                transformationHook.isSafe),
        ]);
        const componentRef = react_1.useRef();
        if (!componentRef.current) {
            function WrapperComponent(props, ref) {
                var _a;
                const val = valRef.current;
                let custComponent = val instanceof hook_1.CustoHook ? val.use(props) : val;
                if (!(custComponent instanceof texts_1.CustoText)) {
                    const newVal = texts_1.CustoText.create(val);
                    custComponent = newVal;
                }
                return custComponent.render(Object.assign(Object.assign({}, props), { ref }), (_a = transformationHookRef.current) === null || _a === void 0 ? void 0 : _a.use);
            }
            WrapperComponent.displayName = "CustoText-" + path;
            componentRef.current = react_1.default.forwardRef(WrapperComponent);
        }
        const Component = componentRef.current;
        return react_1.default.createElement(Component, Object.assign({}, props, { ref: ref, key: key }));
    });
    comp.useRawValue = () => {
        const val = useVal();
        const dependency = val instanceof hook_1.CustoHook ? val.use : null;
        const dependencyRef = react_1.useRef(dependency);
        if (dependencyRef.current !== dependency) {
            // hook has been changed
            if (!(val instanceof hook_1.CustoHook) || !val.isSafe) {
                throw new errors_1.HookChangeError("hook changed in CustoHook (path: " +
                    path +
                    "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
            }
        }
        dependencyRef.current = dependency;
        const custComponent = val instanceof hook_1.CustoHook
            ? val.use({
                disableTextTransformer: true,
            })
            : val instanceof texts_1.CustoText
                ? val
                : texts_1.CustoText.create(val);
        return custComponent.getRaw();
    };
    comp.useValue = () => {
        const val = useVal();
        const transformationHook = getTextTransformationHook && getTextTransformationHook();
        const dep1 = val instanceof hook_1.CustoHook ? val.use : null;
        const dep2 = transformationHook instanceof hook_1.CustoHook
            ? transformationHook.use
            : null;
        const key = hooks_1.useDepsVersion([
            hooks_1.useVersion(dep1, val instanceof hook_1.CustoHook && val.isSafe),
            hooks_1.useVersion(dep2, transformationHook instanceof hook_1.CustoHook &&
                transformationHook.isSafe),
        ]);
        const dependencyRef = react_1.useRef(key);
        if (dependencyRef.current !== key) {
            throw new errors_1.HookChangeError("hook changed in CustoHook (path: " +
                path +
                "). Make sure to wrap your component with WrapInError helper function. Note: CRA still displays error in development mode; just press ESC do hide it");
        }
        dependencyRef.current = key;
        const custComponent = val instanceof hook_1.CustoHook
            ? val.use({
                disableTextTransformer: true,
            })
            : val instanceof texts_1.CustoText
                ? val
                : texts_1.CustoText.create(val);
        return custComponent.useTransformed({}, transformationHook === null || transformationHook === void 0 ? void 0 : transformationHook.use);
    };
    return comp;
}
exports.buildCustoText = buildCustoText;
